import { ihm_viewer__dictionary, locale } from 'Application/i18n/i18nViewer';

export const PatientResume = ({ metas, isConnected, getAnonymous }) => {
    const hasCaseData = !!metas.caseData;
    const patientName = hasCaseData ? metas.caseData.patient.patientName : '';
    const displayedPatientName = isConnected ? patientName : getAnonymous(patientName);
    const caseId = hasCaseData ? metas.caseData.caseID : '';
    const caseDate = hasCaseData ? metas.caseData.caseDate : '';

    return (
        <table id="PatientResume">
            <tbody>
                <tr>
                    <td>{ihm_viewer__dictionary.PATIENT[locale()]}:</td>
                    <td>{hasCaseData ? displayedPatientName : ''}</td>
                </tr>
                <tr>
                    <td>{ihm_viewer__dictionary.CASE_ID[locale()]}:</td>
                    <td>{caseId}&nbsp;&nbsp;&nbsp;&nbsp;</td>
                    <td>{ihm_viewer__dictionary.DATE[locale()]}:</td>
                    <td className="date">{caseDate}</td>
                </tr>
            </tbody>
        </table>
    );
};
